// Events plugin — frontend registration.
// The registry (../registry.js) reads `routes` and `nav` from here.
// To uninstall the plugin's UI: remove this folder and its line in ../registry.js.
import { Tent } from 'lucide-react';
import Events from './Events';
import EventDetail from './EventDetail';
import EventsGate from './EventsGate';

// Flag-gated wrappers: render nothing (redirect home) when the module is disabled.
const GatedEvents = () => <EventsGate><Events /></EventsGate>;
const GatedEventDetail = () => <EventsGate><EventDetail /></EventsGate>;

const eventsPlugin = {
  id: 'events',
  // Gated by this tenant feature-toggle key (from /api/settings/feature-toggles).
  flagKey: 'events_module_enabled',
  routes: [
    { path: '/events', Component: GatedEvents },
    { path: '/events/:id', Component: GatedEventDetail },
  ],
  nav: [
    {
      path: '/events',
      label: 'Events',
      icon: Tent,
      roles: ['super_admin', 'admin', 'operator', 'read_only'],
      afterPath: '/dispatch-view', // insert right after this nav item
      flagKey: 'events_module_enabled',
    },
  ],
};

export default eventsPlugin;
